//types
import { VideoPropsOverrides } from './types';

export const getDefaults = (): VideoPropsOverrides => ({
  Video: {
    controls: true,
  },
});
